import { connect, ConnectedProps } from 'react-redux';
import { RootState } from '../../../../store/root-reducer';
import {
  getFieldsRequest,
  getProspectListByIdsRequest,
  createCustomFieldRequest,
  updateKanbanViewRequest,
  getProspectListRequest,
  getContactListByViewIdRequest,
  getKanbanListRequest,
  getProspectListCountRequest,
  addTagsToProspectsRequest,
  removeTagsFromProspectsRequest,
  getTagsRequest,
  getProspectFiltersFieldsListRequest,
  addTagsToBulkProspectsRequest,
  removeTagsFromBulkProspectsRequest,
} from '../../extra-actions';

import ProspectHeader from './prospect-header';

import {
  FilterGroupLogicPayload,
  Filters,
  ProspectListByIdsPayload,
  ProspectListPayload,
  UpdateCustomFieldRequestPayload,
  UpdateKanbanViewPayload,
} from '../../types';
import {
  setFilters,
  setSelectedKanbanCategoryId,
  resetFilterGroupLogic,
  resetCreateCustomFieldRequest,
  setUpdatedCategoryResponse,
  setShouldFetchInitialList,
  resetBulkRequests,
  resetTags,
  resetProspectFiltersFieldsAttributesValue,
  setIsBulkProspectSelected,
  setProspectViewIdFilter,
  setAddNewCategoryTriggered,
} from '../../prospect-slice';
import {
  getEmailVerificationCreditsRequest,
  getEmailVerificationPlanRequest,
} from '../../../settings/components/billing-subscription/extra-actions';
import { getCustomOutcomeRequest } from '../../../settings/components/custom-outcomes/extra-actions';

const mapStateToProps = (state: RootState) => ({
  getFieldsRequestStatus: state.prospect.getFieldsRequest.status,
  getFieldsRequestError: state.prospect.getFieldsRequest.error,
  getFieldsRequestMessage: state.prospect.getFieldsRequest.message,

  getFilterViewListRequest: state.prospect.getFilterViewListRequest.status,

  prospects: state.prospect.prospects,
  prospectCount: state.prospect.prospectCount,

  fields: state.prospect.fields,

  filters: state.prospect.filters,
  savedFilters: state.prospect.savedFilters,
  outcomes: state.customOutcome.outcomes,

  // Selected prospect rows (kept in redux by prospect list content)
  selectedRowIds: state.prospect.selectedProspectRowId || [],
  isBulkActionOnRows: state.prospect.isBulkProspectSelected || false,

  getProspectListRequestStatus: state.prospect.getProspectListRequest.status,
  getProspectListByIdsRequestStatus:
    state.prospect.getProspectListByIdsRequest.status,
  getProspectListCountRequestStatus:
    state.prospect.getProspectListCountRequest.status,

  isDemoAccount: state.home.isDemoAccount,
  remainingProspectLimit:
    state.home.getPostLoadMetaResponse?.accountUsageQuotaRemaining?.[
      'PROSPECT.ADD'
    ],
  addTagsToProspectsRequestStatus:
    state?.prospect?.addTagsToProspectsRequest?.status,
  removeTagsFromProspectsRequestStatus:
    state?.prospect?.removeTagsFromProspectsRequest?.status,
  sendAddTagsToProspectsRequestStatus:
    state?.prospect?.addTagsToBulkProspectsRequest?.status,
  sendRemoveTagsFromProspectsRequestStatus:
    state?.prospect?.removeTagsFromBulkProspectsRequest?.status,
  deselectedIds: state?.prospect?.deSelectedProspectRowId || [],
  getKanbanList: state?.prospect?.kanbanViewList,
  prospectKanbanContactListViewData:
    state?.prospect?.prospectKanbanContactListViewData,
  prospectKanbanViewData: state.prospect.prospectKanbanViewData,
  createCustomFieldRequestStatus:
    state.prospect.createCustomFieldRequest.status,
  createdKanbanViewId: state.prospect.createdKanbanViewId,
  selectedKanbanCategoryId: state.prospect.selectedKanbanCategoryId,
  activeViewId: state.prospect?.activeViewId || null,
  updateKanbanViewRequestStatus:
    state?.prospect?.updateKanbanViewRequest?.status,
  selectedSavedView: state.prospect.selectedSavedView,
  tags: state?.prospect?.tags,
  createTaskRequestStatus: state.tasks.createTaskRequest.status,
  createTaskRequestMessage: state.tasks.createTaskRequest.message,
  createTaskRequestError: state.tasks.createTaskRequest.error,
  createCustomFieldRequestMessage:
    state.prospect.createCustomFieldRequest.message,
  sendAddTagsToBulkProspectsRequestMessage:
    state.prospect.addTagsToBulkProspectsRequest.message,
  sendAddTagsToBulkProspectsRequestError:
    state.prospect.addTagsToBulkProspectsRequest.error,
  sendRemoveTagsFromBulkProspectsRequestMessage:
    state.prospect.removeTagsFromBulkProspectsRequest.message,
  sendRemoveTagsFromBulkProspectsRequestError:
    state.prospect.removeTagsFromBulkProspectsRequest.error,
  prospectViewIdFilter: state?.prospect?.prospectViewIdFilter,
});

const mapDispatchToProps = {
  sendGetFieldsRequest: () => getFieldsRequest({}),

  sendGetProspectListByIdsRequest: (payload: ProspectListByIdsPayload) =>
    getProspectListByIdsRequest(payload),

  setProspectFilters: (payload: Partial<Filters>) => setFilters(payload),

  sendGetAllOutcomesRequest: () => getCustomOutcomeRequest(),

  sendGetEmailVerificationCreditsRequest: () =>
    getEmailVerificationCreditsRequest(),
  sendGetEmailVerificationPlansRequest: () => getEmailVerificationPlanRequest(),

  setSelectedKanbanCategoryId: (categoryId: number | null) =>
    setSelectedKanbanCategoryId(categoryId),

  resetFilterGroupLogic: () => resetFilterGroupLogic(),

  sendCreateCustomFieldRequest: (payload: UpdateCustomFieldRequestPayload) =>
    createCustomFieldRequest(payload),

  sendAddTagsToProspectsRequest: (payload: any) =>
    addTagsToProspectsRequest(payload),

  sendRemoveTagsFromProspectsRequest: (payload: any) =>
    removeTagsFromProspectsRequest(payload),

  sendGetTagsRequest: () => getTagsRequest(),

  updateKanbanView: (kanbanViewId: number, payload: UpdateKanbanViewPayload) =>
    updateKanbanViewRequest({ kanbanViewId, payload }),
  sendGetProspectListRequest: (payload: ProspectListPayload) =>
    getProspectListRequest(payload),
  sendGetContactListByViewIdRequest: (payload: ProspectListPayload) =>
    getContactListByViewIdRequest(payload),
  sendGetProspectListCountRequest: (payload: ProspectListPayload) =>
    getProspectListCountRequest(payload),
  resetCreateCustomFieldRequest: () => resetCreateCustomFieldRequest(),
  fetchKanbanList: () => getKanbanListRequest(),
  setUpdatedCategoryResponse: (payload: any) =>
    setUpdatedCategoryResponse(payload),
  sendGetProspectFiltersFieldsListRequest: () =>
    getProspectFiltersFieldsListRequest(),
  setShouldFetchInitialList: (payload: boolean) =>
    setShouldFetchInitialList(payload),
  sendAddTagsToBulkProspectsRequest: (payload: any) =>
    addTagsToBulkProspectsRequest(payload),
  sendRemoveTagsFromBulkProspectsRequest: (payload: any) =>
    removeTagsFromBulkProspectsRequest(payload),
  resetBulkRequests: () => resetBulkRequests(),
  resetTags: () => resetTags(),
  resetProspectFiltersFieldsAttributesValue: (payload: any) =>
    resetProspectFiltersFieldsAttributesValue(payload),
  setIsBulkProspectSelected: (payload: boolean) =>
    setIsBulkProspectSelected(payload),
  setProspectViewIdFilter: (payload: FilterGroupLogicPayload) =>
    setProspectViewIdFilter(payload),
  setAddNewCategoryTriggered: (payload: boolean) =>
    setAddNewCategoryTriggered(payload),
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type IProps = ConnectedProps<typeof connector> & {
  viewAddToSequenceModal: VoidFunction;
  viewDeleteProspectModal: VoidFunction;
  viewUnsubscribeProspectModal: VoidFunction;
  viewEmailVerificationModal: VoidFunction;
  fetchProspectListAndCount: (options?: {
    doNoSendFilterGroupLogic?: boolean;
  }) => void;
  viewFiltersModal: VoidFunction;

  selectedRowIds: number[];
  isBulkActionOnRows: boolean;
  renderTagIcon?: () => JSX.Element;
  handleClearSelection: VoidFunction;
  tags: any[];
  sendGetTagsRequest: () => void;
  resetTags: () => void;
  resetProspectFiltersFieldsAttributesValue: (payload: any) => void;
  setIsBulkProspectSelected: (payload: boolean) => void;
};

export default connector(ProspectHeader);
